import { StateCreator } from 'zustand'
import { CampaignCreationState } from '../state'

export interface Step8Slice {
    topupAmount: number
    budget: number
    setTopupAmount: (topupAmount: number) => void
    setBudget: (budget: number) => void
}

export const createStep8Slice: StateCreator<
    CampaignCreationState,
    [],
    [],
    Step8Slice
> = (set) => ({
    topupAmount: 5000,
    budget: 3000,
    setTopupAmount: (topupAmount) => set({ topupAmount }),
    setBudget: (budget) => set({ budget }),
})
